import { Capacitor } from "@capacitor/core";
import type { QueryClient } from "@tanstack/react-query";

// On native, window.location.reload() tears down the WebView and races the
// CapacitorHttp fetch patch / iOS cookie jar on bootstrap, which can leave
// the user appearing logged out. The native path invalidates queries to drop
// stale data and (optionally) re-mounts the current route via the router.
export const reloadApp = (
  queryClient: QueryClient,
  remountRoute?: () => void,
) => {
  if (Capacitor.isNativePlatform()) {
    void queryClient.invalidateQueries();
    remountRoute?.();
  } else {
    window.location.reload();
  }
};
